import { RouterV2Enum } from '@/router/router-names';
import { TabItemType } from '@/components/home-bottom-bar/types';
import { NavIntentEnums } from './types';

// 默认Tab配置
const TabConfigs: TabItemType[] = [
  {
    id: NavIntentEnums.financeHome,
    name: '首页',
    path: RouterV2Enum.home,
    icon: 'nav-loan',
    buttonName: '臻有钱_首页_提现',
    clickMouduleId: 'finance_tagless_homebutton',
  },
  {
    id: NavIntentEnums.financeMyProfile,
    name: '我的',
    path: RouterV2Enum.myProfile,
    icon: 'nav-profile',
    buttonName: '臻有钱_首页_我的',
    clickMouduleId: 'finance_tagless_mebuttion',
  },
];

export default TabConfigs;
